const FeatureType = {
    POINT: "Point",
    POLYGON: "Polygon"
};

export default FeatureType;